/**
 * Service: navigationApi
 */
angular.module('acme.common.service.navigationApi', [])
.service('NavigationApiService', ['$http', function($http) {

    return {

      service: '',
      endpoint: '',

      init: function() {
        this.config.service = this.service;
      },

      config: {

        service: '',

        detail: function (version) {
          return $http({
            method: 'GET',
            url: '/assets/data/navigation/'+ version + '.json'
          });
        }

      }

    };

}]);